import {
    call,
    takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";

export default function* getMatchedChargesList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `payments/${action?.payload?.paymentId}/getMatchedCharges`);

    const charges = res.data.map(charge => {
      return ChargeFactory.create(charge);
    });

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, charges);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchGetMatchedChargesList() {
  yield takeEvery(Constants.GLOBAL_GET_MATCHED_CHARGES_LIST, getMatchedChargesList);
}
